<template lang="pug">
    div(
        class="flex group justify-center items-center"
        :class="{ 'cursor-pointer': action }"
    )
        div(
            v-if="iconComponent"
            class="mr-4"
        )
            component(
                :is="iconComponent"
                class="or-footer-splash-bar-icon text-primary fill-current h-8 w-8 lg:w-10"
            )

        component(
            v-bind="actionComponent.data"
            v-on="actionComponent.events"
            class="text-inherit leading-tight"
        )
            div(
                class="whitespace-nowrap uppercase font-bold text-xl"
                :class="[ subText ? 'lg:text-2xl' : 'lg:text-lg' ]"
            ) {{ text }}

            div(
                v-if="subText"
                class="hidden whitespace-nowrap text-sm lg:block"
                :class="{ 'group-hover:underline': action }"
            )
                | {{ subText }}

</template>

<script>
const Headset = () =>
    import(/* webpackChunkName: "headset-icon" */ '@/assets/common/headset?inline')
const Phone = () => import(/* webpackChunkName: "phone-icon" */ '@/assets/common/phone?inline')
const Person = () => import(/* webpackChunkName: "person-icon" */ '@/assets/common/person?inline')
const ChatDouble = () =>
    import(/* webpackChunkName: "chatDouble-icon" */ '@/assets/common/chat?inline')
const ChatRound = () =>
    import(/* webpackChunkName: "chatRound-icon" */ '@/assets/common/chatBubble?inline')
const ChatSquareOutline = () =>
    import(
        /* webpackChunkName: "chatSquareOutline-icon" */ '@/assets/common/chatBubbleRoundedSquare?inline'
    )
const Truck = () =>
    import(/* webpackChunkName: "shippingTruck-icon" */ '@/assets/common/shippingTruck?inline')
const TruckOutline = () =>
    import(/* webpackChunkName: "shippingTruckOutline-icon" */ '@/assets/common/shiptruck?inline')
const Box = () =>
    import(/* webpackChunkName: "shippingBox-icon" */ '@/assets/common/shippingBox?inline')

export default {
    name: 'SplashBarItem',
    props: {
        text: {
            type: String,
            required: true,
        },
        subText: {
            type: String,
            default: null,
        },
        icon: {
            type: String,
            default: null,
        },
        action: {
            type: String,
            default: null,
        },
    },
    computed: {
        iconComponent() {
            switch (this.icon) {
                case 'box':
                    return Box

                case 'chat-double':
                    return ChatDouble

                case 'chat-round':
                    return ChatRound

                case 'chat-square-outline':
                    return ChatSquareOutline

                case 'headset':
                    return Headset

                case 'phone':
                    return Phone

                case 'person':
                    return Person

                case 'truck':
                    return Truck

                case 'truck-outline':
                    return TruckOutline

                default:
                    return null
            }
        },
        actionComponent() {
            const data = {
                is: 'div',
            }

            const events = {}

            switch (this.action) {
                case 'call':
                    data.is = 'a'
                    data.href = `tel:${this.$config.runtime.theme.phoneNumbers.general}`

                    break

                case 'chat':
                    if (this.$chat.enabled) events.click = this.$chat.open
                    break

                default:
                    break
            }

            return {
                data,
                events,
            }
        },
    },
}
</script>
